export const GITHUB_TOKEN = "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";
